export default __webpack_public_path__ + "static/media/SwamijiNew1.40230bfe.JPG";